/* eslint-disable no-useless-escape */
function textToSnake(str: string): string {
  return str?.replace(/[^a-z0-9A-Z]/g, '_').toLowerCase() ?? ''
}

export default textToSnake
